class SaleCategoryNav extends HTMLElement {
  constructor() {
    super();
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.nav = this.querySelector('.sale-landing__nav');
    this.placeholder = this.querySelector('.sale-landing__nav-placeholder');
    if (!this.nav || !this.placeholder) return;

    this.updateMeasurements();
    this.addEventListener('click', this.handleClick);
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleResize);
    this.handleScroll();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }

  getStickyOffset() {
    const value = getComputedStyle(this).getPropertyValue('--sale-nav-sticky-offset');
    return Number.parseFloat(value) || 0;
  }

  getHeaderOffset() {
    const header = document.querySelector('.section-header');
    if (!header) return 0;

    const rect = header.getBoundingClientRect();
    const style = getComputedStyle(header);
    const isSticky = style.position === 'sticky' || style.position === 'fixed';
    const isVisibleAtTop = rect.bottom > 0 && rect.top <= 1;

    return isSticky && isVisibleAtTop ? Math.max(0, rect.bottom) : 0;
  }

  getTotalStickyOffset() {
    return this.getHeaderOffset() + this.getStickyOffset();
  }

  updateOffsets() {
    const headerOffset = this.getHeaderOffset();
    this.style.setProperty('--sale-header-offset', `${headerOffset}px`);
    document.documentElement.style.setProperty('--sale-header-offset', `${headerOffset}px`);
  }

  updateMeasurements() {
    const wasSticky = this.nav.classList.contains('is-sticky');

    if (wasSticky) {
      this.nav.classList.remove('is-sticky');
      this.placeholder.style.height = '';
    }

    this.navHeight = this.nav.offsetHeight;
    this.originTop = this.placeholder.getBoundingClientRect().top + window.scrollY;
    document.documentElement.style.setProperty('--sale-nav-height', `${this.navHeight}px`);
    this.updateOffsets();

    if (wasSticky) this.setSticky(true);
  }

  setSticky(shouldStick) {
    this.nav.classList.toggle('is-sticky', shouldStick);
    this.placeholder.style.height = shouldStick ? `${this.navHeight}px` : '';
  }

  handleScroll() {
    this.updateOffsets();
    const shouldStick = window.scrollY + this.getTotalStickyOffset() >= this.originTop;
    this.setSticky(shouldStick);
  }

  handleResize() {
    this.updateMeasurements();
    this.handleScroll();
  }

  handleClick(event) {
    const button = event.target.closest('button[data-target]');
    if (!button || !this.contains(button)) return;

    const id = button.dataset.target;
    const target = document.getElementById(id);
    if (!target) return;

    const targetTop =
      target.getBoundingClientRect().top +
      window.scrollY -
      this.navHeight -
      this.getTotalStickyOffset();

    window.scrollTo({ top: targetTop, behavior: 'smooth' });
  }
}

if (!customElements.get('sale-category-nav')) {
  customElements.define('sale-category-nav', SaleCategoryNav);
}
